const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.25A5.75 5.75 0 0 0 6.25 8v1.5a.75.75 0 0 0 1.5 0V8a4.25 4.25 0 0 1 8.5 0v1.5a.75.75 0 0 0 1.5 0V8A5.75 5.75 0 0 0 12 2.25M7.75 14.5a.75.75 0 0 0-1.5 0V16a5.75 5.75 0 0 0 11.5 0v-1.5a.75.75 0 0 0-1.5 0V16a4.25 4.25 0 0 1-8.5 0z"/></svg>';
export {
  a as w
};
